import React, { useEffect, useState } from 'react'
import TopBar from '../components/menu/TopBar'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../components/reactTable/Table'
import { Eye } from 'react-feather'
import { language } from '../stores/slices/languageSlice'
import { Tooltip } from "antd";
import { fetchClaimDetails, resetClaimDetails } from '../stores/slices/claimDetailSlice'
import { Link, useNavigate } from 'react-router-dom';


function Claims() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.claimListSlice.value)
    const selectedLanguage = useSelector(language).Claims
    const [claimList, setClaimList] = useState([])

    useEffect(() => {
        let sortList = [];
        let listData = JSON.stringify(data);
        listData = JSON.parse(listData);
        sortList = listData
        sortList = sortList?.sort(
            (val, temp) =>
                new Date(temp.submissionDate) - new Date(val.submissionDate)
        );
        setClaimList(sortList)
    }, [data])


    const viewClaim = (props) => {
        let data = props.row.original ? props.row.original : props;
        dispatch(resetClaimDetails());
        dispatch(fetchClaimDetails({ PCaseID: data.claimID, prgData: data.program }))
        return navigate('/claims/Details')
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'POE ID',
                accessor: '',
            },
            {
                Header: 'POE ID',
                accessor: 'claimID',
            },
            {
                Header: 'Check No',
                accessor: 'checkNo',
            },
            {
                Header: 'Patient Name',
                accessor: 'patientName',
                // disableSortBy: true,
            },
            {
                Header: 'Submission Date',
                accessor: 'submissionDate',
            },
            {
                Header: 'Amount Submitted',
                accessor: 'submittedAmount',
            },
            {
                Header: 'Paid Amount',
                accessor: 'paidAmount',
                // disableSortBy: true,
            },
            {
                Header: 'Status',
                accessor: 'status',
            },
            {
                Header: 'Action',
                accessor: 'actions',
                disableSortBy: true,
                Cell: props => {
                    return <div className="d-flex justify-content-center align-items-center">
                        <Tooltip placement='top' title={'View Claim'}><a className="d-flex align-items-center cursor-pointer" onClick={() => viewClaim(props)}> <Eye /></a></Tooltip>
                    </div>
                },
            },
        ],
        []
    );

    return (
        <div className="content">
            <TopBar />
            <div className="grid columns-12 gap-6 px-8 bg_white">
                <div className="g-col-12 ">
                    <div className="g-col-12 g-col-xl-9">
                        <div className="intro-y d-flex flex-column flex-sm-row align-items-center mt-8">
                            <h2 className="fs-lg fw-medium me-auto">
                                {selectedLanguage.heading}
                            </h2>
                            <div className="d-lg-flex intro-y">
                                <Link to={"/createApp"} className="btn verifyAddres shadow-md me-2">{selectedLanguage.createExpenditure}</Link>
                            </div>
                        </div>
                        <Table columns={columns} data={[...new Set(data)]} showPageDataCount={5} searchFilter={true} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Claims